import {axiosInstanceUnauth} from "./setup/axiosInstance";
import ENDPOINTS from "./setup/constants";

const getBackendInfo = async (token) => {
	return axiosInstanceUnauth.get(ENDPOINTS.backend, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${token}`
		}
		}).then((res) => {
			return res.data;
		}).catch((error) => {
			console.error('Request Failed:', error.config);
			if (error.response) {
				console.error('Status:',  error.response.status);
				console.error('Data:',    error.response.data);
				console.error('Headers:', error.response.headers);
			} else {
				console.error('Error Message:', error.message);
			}
	
			return Promise.reject(error.response || error.message);
		})
};

const backendInfoAPI = {
	getBackendInfo: getBackendInfo
}

export default backendInfoAPI

